import { ISequence } from "./sequence";
export class ISession extends ISequence {
}
//# sourceMappingURL=session.js.map